import { WIDGET_FORM_INPUT_SIMPLE_SELECT } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const SimpleSelectInputWidget: WidgetRegistryEntry = {
  component: () => import("./simple-select-input-widget.component").then((m) => m.SimpleSelectInputWidgetComponent),
  name: WIDGET_FORM_INPUT_SIMPLE_SELECT
};
